export default __webpack_public_path__ + "static/media/bathroom-Up_AQP-INDOOR-ZID-12,5-CM.e446120a.jpg";